import React, { useMemo } from 'react'
import { useTypedSelector } from 'src/State/RootReducer'
import { Box, Stack, Typography } from '@mui/material'
import { format } from '@e3dc-react/shell/Libs/date'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { OfflineIndicator } from 'src/Libs/offline-mode'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(2),
  },
}))
interface Props {
  showOfflineIndicator?: boolean
}

const LiveDataTitle: React.FC<Props> = ({ showOfflineIndicator = false }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const liveData = useTypedSelector(state => state.storage.liveData)

  const liveDataTime = useMemo(
    () => (
      <>{liveData?.time && <Typography variant="caption">{format(new Date(liveData.time), t('common.format.date-fns-date-time'))}</Typography>}</>
    ),
    [liveData?.time, t]
  )

  return (
    <Box className={classes.titleWrapper}>
      <Stack>
        <Typography variant="h3">{t('dashboard.liveView.title')}</Typography>
        {liveDataTime}
      </Stack>
      {showOfflineIndicator && <OfflineIndicator />}
    </Box>
  )
}

export default LiveDataTitle
